import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import docsUrl from './schema-docs.md';

export const SchemaDocsPanel: React.FC = () => {
    const [content, setContent] = useState<string>('');

    useEffect(() => {
        const loadDocs = async () => {
            const response = await fetch(docsUrl);
            const markdown = await response.text();
            setContent(markdown);
        };
        loadDocs();
    }, []);

    return (
        <div className="border rounded-lg bg-card p-4 space-y-3">
            <h3 className="font-semibold">Schema Documentation</h3>
            <div className="prose prose-sm max-w-none">
                <Markdown>{content || 'Loading documentation...'}</Markdown>
            </div>
        </div>
    );
};
